import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    main: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      color: '#FFF',

      [media.desktop]: {
        display: 'flex',
        flexDirection: 'column',
      },
    },

    header: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '20px',
    },

    brandingContainer: {
      height: '72px',
      display: 'flex',
    },

    logo: {
      display: 'flex',
      height: '51px',
    },

    copy: {
      width: '200px',
      fontSize: 18,
      flexGrow: 1,
      marginLeft: 20,
      fontWeight: 700,
    },

    heroImageContainer: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,

      [media.desktop]: {
        flexGrow: 1,
      },
    },

    closedTextContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      flexGrow: 1,
      margin: '0 auto',
      padding: '0px 15px',
      maxWidth: 500,
      [media.desktop]: {
        maxWidth: 750,
      },
    },

    closedText: {
      color: '#FFF',
      fontSize: 25,
      lineHeight: '35px',
      fontWeight: 700,
      textAlign: 'center',
      padding: '0 15px',
      marginBottom: 10,

      [media.tablet]: {
        fontSize: 40,
        lineHeight: '55px',
      },
    },
    closedTextSecondary: {
      fontSize: 16,
      lineHeight: '20px',
      textAlign: 'center',

      [media.tablet]: {
        fontSize: 24,
        lineHeight: '34px',
      },

      [children('a')]: {
        color: palette.red,
        textDecoration: 'underline',
      },
    },
  });
};
